import React from "react";
import "./Brochure.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";


const Brochure = () => {
    return (
        <div className="brochure-wrapper">

            {/* LOGO */}
            <div className="logo_Brochure">
                <Link to="/"><img  src="/images/auditlogo.png" alt="Logo" /></Link>
            </div>

            {/* HERO */}
            <div className="hero">
                <h1>India’s Smart GST Billing & ERP Software</h1>
                <p>Professional • Secure • Powerful • Business Ready</p>

                <a
                    href="https://wa.me/919032032612?text=7 days Free Trial"
                    className="btn-main"
                >
                    Get 7 Days Free Trial
                </a>
            </div>

            {/* TRUST BAR */}
            <div className="trust-bar">
                ✅ 10+ Years Experience | ✅ Trusted by 2000+ Businesses
            </div>

            {/* FEATURES */}
            <section className="features">
                <h2 className="section-title">Powerful Features</h2>

                <div className="grid">
                    {[
                        {
                            icon: "bi-lightning-charge-fill",
                            title: "Ultra Fast GST Billing",
                            desc: "Instant invoice creation with barcode & thermal printer support.",
                        },
                        {
                            icon: "bi-file-earmark-text-fill",
                            title: "Complete GST Reports",
                            desc: "GSTR-1, GSTR-3B, purchase & sales reports auto-ready.",
                        },
                        {
                            icon: "bi-box-seam",
                            title: "Advanced Inventory",
                            desc: "Batch, expiry, godown & multi-warehouse stock control.",
                        },
                        {
                            icon: "bi-phone-fill",
                            title: "Mobile App Access",
                            desc: "Monitor business from anywhere anytime.",
                        },
                        {
                            icon: "bi-whatsapp",
                            title: "WhatsApp Billing",
                            desc: "Send invoices directly to customers.",
                        },
                        {
                            icon: "bi-graph-up-arrow",
                            title: "Live Profit Dashboard",
                            desc: "Real-time analytics & smart reports.",
                        },
                        {
                            icon: "bi-shield-check",
                            title: "Secure Data Backup",
                            desc: "Cloud & local automatic backup system.",
                        },
                        {
                            icon: "bi-people-fill",
                            title: "Multi-User Access",
                            desc: "Role-based permissions & staff control.",
                        },
                        {
                            icon: "bi-cash-coin",
                            title: "Outstanding Tracking",
                            desc: "Receivables, payables & credit management.",
                        },
                        {
                            icon: "bi-receipt",
                            title: "Purchase & Sales Orders",
                            desc: "Complete order lifecycle management.",
                        },
                        {
                            icon: "bi-bar-chart-fill",
                            title: "Business Reports",
                            desc: "Daily, monthly & yearly performance reports.",
                        },
                        {
                            icon: "bi-arrow-repeat",
                            title: "Automatic Updates",
                            desc: "Latest GST compliance & software upgrades.",
                        },
                    ].map((item, index) => (
                        <div className="card_Brochure" key={index}>
                            <i className={`bi ${item.icon}`}></i>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* PRICE SECTION */}
            <div className="price">
                <div className="offer-badge">
                    🎉 Financial Year Closing Offer – ₹6,000 OFF
                </div>

                <div className="old-price">Regular Price ₹36,000</div>
                <div className="new-price">Today Offer Price ₹30,000</div>

                <p className="price-line">One-Time Payment • Lifetime License</p>
                <p className="price-sub">
                    No Monthly Charges • Full Data Control
                </p>

                <div className="amc-box">
                    <strong className="amc-title">
                        Annual Support & Updates (AMC)
                    </strong>
                    <br />
                    <br />
                    After 1 Year – Optional Renewal (20%)<br />
                    ✔ Software Updates<br />
                    ✔ GST & Compliance Changes<br />
                    ✔ Latest Versions<br />
                    ✔ Technical Support Assistance
                </div>
            </div>

            {/* FOOTER BUTTONS */}
            <div className="footer">
                <a href="tel:+919032032612" className="call">
                    <i className="bi bi-headset"></i> Call
                </a>

                <a
                    href="https://wa.me/919032032612?text=I want Demo"
                    className="wa"
                >
                    <i className="bi bi-whatsapp"></i> WhatsApp
                </a>
            </div>

        </div>
    );
};

export default Brochure;